const Form018EN = {
    stepName: {
        importantNotes: "Important Notes",
        applicationInfo: "Application Information",
        confirmation: "Confirmation",
    },
    label: {
        note: "Note",
        completedByEDB: "To be completed by the Education Bureau",
    },
    formLabel: {
        refNo: "Ref No.",
        refNo2: "(For office use only)",
        name: "Name of Applicant",
        name2: " (must be identical with that of the applicant's HK Identity Card):",
        nameEn: "(English)",
        nameCn: "(Chinese)",
        address: "Correspondence Address",
        tel: "Contact Telephone No.:",
        contactTelephone: "Contact Telephone No.(School / Office)",
        shoolOrOfficeOp: {
            school: "School Contact Telephone No.",
            office: "Office Contact Telephone No.",
        },
        workTel: "Contact Telephone No.",
        homeOrMoblieOp: {
            home: "Home Contact Telephone No.",
            mobile: "Mobile Contact Telephone No.",
        },
        contactTelephoneNo: "Contact Telephone No.(Home / Mobile)",
        fax: "Fax No.",
        email: "E-mail Address",
        cardLabel: "HK Identity Card / Passport No.:",
        idCard: "HK Identity Card",
        passPort: "Passport",
        teacher: "Registered Teacher / Permitted Teacher No.:",
        registeredT: "Registered Teacher No.",
        permittedT: "Permitted Teacher No.",
        idCardOrpassPortOP: {
            idCard: "HK Identity Card",
            passPort: "Passport",
        },
        registeredOrpermittedOp: {
            registeredT: "Registered Teacher",
            permittedT: "Permitted Teacher",
        },
        shoolOrOrganisationOp: {
            school: "School",
            organisation: "Organisation",
        },
        applicant: "Name and Address of Applicant's School / Organisation:",
        organisation: "Organisation",
        schoolTypeTitle: "Type of School (if applicable):",
        schoolType: {
            primary: "Primary",
            secondary: "Secondary",
            special: "Special",
        },
        schoolType2: {
            government: "Government",
            aided: "Aided",
            dss: "DSS",
            others: "Others (Please specify)",
        },
        teachingExperience: "Teaching Experience:",
        teachingExperienceOp: {
            5: "5 Years",
            "6–10": "6 – 10 Years",
            "11–15": "11 – 15 Years",
            "over 15": "over 15 Years",
        },
        currentPosition: "Current Position in School / Organisation:",
        analysis: "Completion of Needs Analysis:",
        yesOrNo: {
            yes: "Yes",
            no: "No",
        },
        certificate: "Issue date of certificate",
        completion: "Completion of Preparation for Principalship Course:",
        submittedPortfolioBefore: "*Submitted Portfolio Before:",
        attainedCFP: "Attained CFP:",
        declaration: "Declaration",
        termsConditions:
            "I hereby apply for restarting the CFP process and I declare that the information contained in this application form is true and accurate.",
        applicantSignature: "Applicant's Signature",
        date: "Date",
        nil: "Nil",
        attachmentTooltip:
            "Please attach copies of certificate(s)/certifying letter(s).",
        attachment: "Annex",
    },
    confirmation: {
        label1: " No.",
        label2: "Name and Address of ",
        label3: "",
        label4: "Current Position in ",
        label5: "",
        label6: "Others",
    },
    importantNotes: {
        note1: "Please make ready the scanned copies / images of the supporting documents in the file format of JPG, PNG or PDF if necessary:",
        note2: "(The maximum size of all files should not exceed 10MB.)",
        note3: 'You need an "iAM Smart" account with digital signing function for the online application form.',
        iamSignCheck:
            "I understand applicant needs to have an “iAM Smart+” account to process the application.",
    },
    errorMsg: {
        ref: "ref No.",
        nameEn: "name(English)",
        nameCn: "name(Chinese)",
        teacherNo: "teacher No.",
        beforeToday: "Please input a date before today",
        date: "Please input a valid issue date of certificate",
    },
};
export default Form018EN;
